// vim: set ts=2 sw=2 et ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * File for storing string constants for users (like error messages)
 *
 *
 * CTAG:COMMUNITY:STORES
 */


var module; UMD(module, {
  'minted:m': ['M'],
  'minted:config/stores_shared_constants_config': []
})(this, function (m_module) {

  "use strict";
  var M = m_module.M;

  M.View = M.View || {};
  M.Config = M.Config || {};
  M.View.StorefrontTools = M.View.StorefrontTools || {};
  M.View.StorefrontTools.Constants = M.View.StorefrontTools.Constants || {};

  var sectionNameMaxChars =
    M.Config['StoresSharedConstantsConfig']['section_name_max_chars'];
  var sectionDescMaxChars =
    M.Config['StoresSharedConstantsConfig']['description_max_chars'];

  // Error messages
  M.View.StorefrontTools.Constants.ErrorMsg = {
    userIdle: 'There hasn\'t been any activity on this page for at least 10 minutes. ' +
      'Click OK to reload this page and continue.',
    unexpectedError: 'We\'re sorry. It\'s not you, it\'s us. Please try again'
    + ' later.',
    featureProductsLimitExceeded: 'You have 12 featured products. To feature ' +
      'any new products, you must remove something first.',
    sectionName: {
      textLengthTooLong: 'Your section name must be less than ' +
        sectionNameMaxChars + ' characters.',
      textEmpty: 'Your section name cannot be blank.',
      textDuplicated: 'Section names must be different from other ' +
        'sections in your store.'
    },
    sectionDesc: {
      textLengthTooLong: 'Your description must be less than ' +
        sectionDescMaxChars + ' characters.'
    },
    unsavedChanges: 'You have unsaved changes on this page. To keep your ' +
      'changes, please wait at least 10 seconds before navigating to a new ' +
      'page.',
    sectionsExceeded: 'You have 100 sections. Delete a section to make room ' +
      'for this new section.',
    tooManyActiveSections: 'You have 10 active sections. To publish a new ' +
      'section, you must hide a section first.',
    tooManyActiveSectionsTitle: 'Unable to publish this section',
    featureProductsLimitExceededTitle: 'Unable to feature this product',
    unableToCurateProduct: 'There was a problem adding this product to your' +
      ' store. Please try again later.',
    unableToRemoveProduct: 'This product has already been removed from your' +
      ' store. This often happens when you make changes in multiple browser tabs.'
  };

  M.View.StorefrontTools.Constants.SectionVisibilityCaptions = {
    ACTIVATE: {
      ACTIVE: 'If you make this section active, all unpublished changes will ' +
        'be visible to customers that visit your store.',
      HIDDEN: 'This section is currently hidden.'
    },
    HIDE: {
      ACTIVE: 'This section is currently active.',
      HIDDEN: 'Hiding this section will prevent customers from seeing it ' +
        'in your store. Any unpublished changes will be preserved.'
    },
    CREATE: {
      ACTIVE: '',
      HIDDEN: 'All new sections are hidden by default. You\'ll have to ' +
        'click "Make Active" to make the section visible to customers.'
    }
  };

  M.View.StorefrontTools.Constants.DialogTitle = {
    CREATE_NEW_SECTION: 'create new section',
    RENAME_SECTION: 'rename section',
    SECTION_VISIBILITY: 'edit section visibility',
    REACHED_MAX_SECTIONS: 'unable to create this section',
    UNABLE_TO_SAVE: 'unable to save changes',
    RELOAD_PAGE: 'reload page',
    UNABLE_TO_CURATE_PRODUCT: 'unable to curate product',
    UNABLE_TO_REMOVE_PRODUCT: 'unable to remove product',
    UNEXPECTED_ERROR: 'unexpected error'
  };

  M.View.StorefrontTools.Constants.DiscardDialogInfo = {
    TITLE: 'Discard unpublished changes',
    DESCRIPTION: 'Are you sure you want to discard your unpublished changes?',
    PRIMARY_BUTTON: 'Keep Changes',
    SECONDARY_BUTTON: 'Discard Changes'
  };

  M.View.StorefrontTools.Constants.DeleteDialogInfo = {
    TITLE: 'Delete section',
    DESCRIPTION: 'Are you sure you want to delete this section?',
    PRIMARY_BUTTON: 'Keep Section',
    SECONDARY_BUTTON: 'Delete Section'
  };

  /**
   * renderOtherProducts & renderProductsNotInSection need to match
   * minted.web.views.community.storefront.SMT_NUM_PRODUCTS_PER_PAGE
   */
  M.View.StorefrontTools.Constants.renderFnKeyToItemsPerPage = {
    renderFeaturedProducts: 12,
    renderOtherProducts: 25,
    renderActiveSections: 10,
    renderHiddenSections: 10,
    renderProductsInSection: 10,
    renderProductsNotInSection: 25,
    renderSearchResults: 10
  };

  M.View.StorefrontTools.Constants.ButtonText = {
    PUBLISH_BUTTON: {
      ACTIVE: 'publish section',
      HIDDEN: 'make active',
      STORE_HOME: 'publish store home',
    },
    PREVIEW_BUTTON: {
      STORE_HOME: {
        PUBLISHED: 'view store home',
        DRAFT: 'preview store home'
      },
      SECTION_DETAIL: {
        PUBLISHED: 'view section',
        DRAFT: 'preview section'
      }
    },
    ADD_NEW_SECTION: 'Add New Section',
    VIEW_STORE: 'View Store',
    MAKE_CHANGES: 'make changes',
    MANAGE_STORE_HOME: 'manage store home'
  };

  // merge states for row order
  M.View.StorefrontTools.Constants.RowOrderMergeState = {
    ORDER_MERGED: 0,
    ORDER_MERGING: 1,
    ORDER_NEEDS_MERGE: 2,
    ORDER_MERGE_ABORT: 3
  };

  M.View.StorefrontTools.Constants.PreviewBarStatus = {
    HIDDEN: 'hidden section',
    DRAFT: 'unpublished changes',
    PUBLISHED: 'published'
  };

  return { };

});
